import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import "./AppBar.css";

const AppBar = ({ showTitle = true }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const [activeTab, setActiveTab] = useState(0);

	// Update active tab based on current path
	useEffect(() => {
		const currentTab = tabs.findIndex(tab => tab.path === location.pathname);
		if (currentTab !== -1) {
			setActiveTab(currentTab);
		}
	}, [location.pathname]);

	const handleTabClick = (index, path) => {
		setActiveTab(index);
		navigate(path);
	};

	const handleTitleClick = () => {
		navigate('/');
	};

	return (
		<div className="app-bar">
			<div className="app-bar-content">
				<div className="left">
					<span className="title-role">ROHITH PEDDI</span>
				</div>
				<div className="right">
					<div className="nav-tabs">
						{tabs.map((tab, index) => (
							<div
								key={tab.label}
								className={`nav-tab ${index === activeTab ? 'active' : ''}`}
								onClick={() => handleTabClick(index, tab.path)}
							>
								<span className="tab-text">{tab.label}</span>
								<div className="tab-indicator"></div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

const tabs = [
	{ label: 'Home', path: '/' },
	{ label: 'Publications', path: '/research' },
	{ label: 'Experience', path: '/experience' },
	{ label: 'Awards', path: '/awards' },
	{ label: 'Service', path: '/service' }
];

export default AppBar;
